const config = (token: string) => {
  return {
    withCredentials: true,
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
  };
};

export default config;
